import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { localize } from 'react-localize-redux';
import capitalize from 'capitalize';
import Icon, { LoadingOutlined } from '@ant-design/icons';

import { Step, Stepper, StepLabel, StepContent } from 'material-ui/Stepper';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';
import { MdAccessTime as TimeIcon } from 'react-icons/md';

import TicketStatus from 'components/shared/TenantTicketStatus';
import ProgressInEnglish from 'components/shared/progressInEnglish';
import ProgressConcert from 'components/shared/concertProgress';
import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import PrintButton from 'components/shared/PrintButton';
import TenantMaintenanceNotes from 'components/tenant_app/components/TenantMaintenanceNotes';

import { getSuiteRooms } from 'helpers/SelectOptions';
import { hostIsBoardwalk } from 'helpers/CurrentWindowLocation';
import { toFriendlyDateString } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { serviceRequestVerbiage, serviceRequestOptions } from 'helpers/VerbiageHelper';
import { muiThemeNext } from 'helpers/MUIFiles';
import { getTranslatedString } from 'helpers/i18n';

const FORM_NAME = 'tenant_update_maintenance';

const style = {
  padding_right: {
    padding: '0px 5px',
    fontWeight: '800',
  },
  padding_top_and_right: {
    padding: '20px 5px 0px 0px',
    textAlign: 'right',
  },
  receipt_header: {
    margin: '5px -20px 10px -20px',
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    textAlign: 'center',
  },
  rent_breakdown: {
    fontSize: '15px',
    marginTop: '15px',
  },
  second_tier: {
    fontSize: '14px',
    color: '#6F6F6F',
  },
};
class TenantMaintenanceDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, confirmDialogOpen: false };
  }

  printReceipt() {
    document.getElementById('root').style.display = 'none';
    const buttons = document.getElementsByTagName('button');
    for (var i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      button.style.display = 'none';
    }
    window.print();
    for (i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      button.style.display = '';
    }
    document.getElementById('root').style.display = '';
  }

  toggleConfirmDialog = () => {
    this.setState({ confirmDialogOpen: !this.state.confirmDialogOpen });
  };

  getPhotos = () => {
    return this.props.photos || [];
  };

  closeDialog = () => {
    this.props.toggleDialog();
  };

  getSuiteLocation = () => {
    if (!this.props.ticketInfo || !this.props.ticketInfo.suite_location) return '';

    let suiteLocation = this.props.ticketInfo.suite_location;
    if (!this.props.propertyTypes) return suiteLocation;

    const suiteLocationObject = getSuiteRooms(true, this.props.propertyTypes).find(
      (room) => room.value === suiteLocation
    );
    if (!suiteLocationObject) return suiteLocation;

    return this.props.translate(suiteLocationObject.label);
  };

  render() {
    const data = this.props.ticketInfo || {};
    const isTicketOpen = data.status ? !data.status.match(/Fixed|Closed/i) : false;
    const scheduled_at = data.scheduled_at ? toFriendlyDateString(data.scheduled_at) : 'n/a';
    let customMultilineStyle = muiThemeNext(AccentColor());

    customMultilineStyle.overrides = {
      MuiInputBase: {
        root: {
          fontFamily: 'Circular',
        },
        inputMultiline: {
          fontSize: '14px',
          lineHeight: '18px',
        },
      },
      MuiOutlinedInput: {
        root: {
          backgroundColor: 'white',
          fontFamily: 'Circular',
        },
      },
    };

    const stepIndex = (this.props.ticketInfo && this.props.ticketInfo.stepIndex) || 0;

    const ticketOpenedOptions = {
      serviceRequest: this.props.translate('portal.serviceRequestDescriptor.ticketOpened'),
      requestForMaintenance: this.props.translate(
        'portal.serviceRequestDescriptor.ticketOpenedRFM'
      ),
    };

    const cancelTicketOptions = {
      serviceRequest: this.props.translate('cancelTicket'),
      requestForMaintenance: this.props.translate('cancelTicketRFM'),
    };

    const cancelTicketAreYouSureOptions = {
      serviceRequest: this.props.translate('cancelTicket.areYouSureRFM'),
      requestForMaintenance: this.props.translate('cancelTicket.areYouSureRFM'),
    };

    const displayScheduledAt = data.subject && data.scheduled_at;
    return (
      <div>
        <Dialog
          id="maintenance-ticket-dialog-container"
          fullScreen={this.props.fullScreen}
          open={this.props.isOpen}
          onClose={this.closeDialog}
          aria-label={`view ${serviceRequestVerbiage('plural')}`}
          classes={{
            paper: 'form-dialog',
          }}
        >
          <DialogTitle>
            <div style={{ position: 'relative', marginTop: '-20px' }}>
              <h3
                style={{
                  fontFamily: 'Circular-Bold',
                  width: 'calc(100% - 110px)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  display: 'block',
                  textOverflow: 'ellipsis',
                }}
              >
                {capitalize(data.subject || '')}{' '}
              </h3>
              <div style={{ position: 'absolute', top: '-15px', right: '15px' }}>
                <h3>{data.status && <TicketStatus status={data.status} />}</h3>
              </div>
              {['Portal Request - Maintenance', 'Portal Request - Other', 'Kiosk Request'].includes(
                data.request_type
              ) &&
                data.ticket_number && (
                  <div style={{ textAlign: 'center', marginTop: '-10px', fontSize: '12px' }}>
                    <button
                      type="button"
                      className="link-button"
                      onClick={this.toggleConfirmDialog}
                    >
                      <h6>{serviceRequestOptions(cancelTicketOptions)}</h6>
                    </button>
                  </div>
                )}
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="row">
              {this._renderAddress()}
              <div className="col-xs-4">
                {data.subject && (
                  <PrintButton
                    printHeader={data.subject}
                    printElementID="maintenance-ticket-dialog-container"
                    hideElementsByIds={['appbar', 'maintenanceTicketsDialog']}
                    style={{
                      color: '#fff',
                      backgroundColor: AccentColor(),
                      float: 'right',
                      paddingLeft: '0px',
                    }}
                  />
                )}
              </div>
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
              <div className="col-xs-7" style={{ padding: '0px 5px' }}>
                <p>
                  {displayScheduledAt && (
                    <span>
                      <TimeIcon size={16} style={{ verticalAlign: 'text-bottom' }} />
                      &nbsp;
                      <b>
                        {scheduled_at} {!hostIsBoardwalk() && `- ${data.scheduled_range_verbiage}`}
                      </b>
                    </span>
                  )}
                </p>
              </div>
            </div>

            <div className="row" style={style.receipt_header}>
              <div className="col-xs-12">
                <p style={{ margin: '0', textTransform: 'uppercase' }}>
                  {' '}
                  {this.props.translate('progress')}{' '}
                </p>
              </div>
            </div>

            <Stepper
              style={{ marginBottom: '10px' }}
              activeStep={stepIndex}
              orientation="vertical"
              connector={<span className="custom-connector" />}
            >
              <Step>
                <StepLabel>{serviceRequestOptions(ticketOpenedOptions)}</StepLabel>
                <StepContent>
                  <div className="row" style={style.rent_breakdown}>
                    <p>{this._renderProgressVerbiage()}</p>
                  </div>
                </StepContent>
              </Step>
              <Step>
                <StepLabel>
                  {this.props.translate('portal.serviceRequestDescriptor.inProgress')}
                </StepLabel>
                <StepContent>
                  <div className="row" style={style.rent_breakdown}>
                    <p>{this._renderProgressVerbiage()}</p>
                  </div>
                </StepContent>
              </Step>
              <Step>
                <StepLabel>{this.props.translate('maintenanceStatus.fixed')}</StepLabel>
                <StepContent>
                  <div className="row" style={style.rent_breakdown}>
                    <p>{this._renderProgressVerbiage()}</p>
                  </div>
                </StepContent>
              </Step>
            </Stepper>

            <div className="row" style={style.receipt_header}>
              <div className="col-xs-12">
                <p style={{ margin: '0', textTransform: 'uppercase' }}>
                  {' '}
                  {this.props.translate('details')}{' '}
                </p>
              </div>
            </div>

            <div className="row" style={style.rent_breakdown}>
              <p>
                <b>
                  {' '}
                  {data.ticket_number ? (
                    <span>
                      {this.props.translate('ticket')}
                      {' #'}
                      {data.ticket_number}
                    </span>
                  ) : (
                    <span style={{ fontStyle: 'italic' }}>
                      {this.props.translate('requestCreatedPendingSync')}{' '}
                      <Icon component={LoadingOutlined} spin />
                    </span>
                  )}{' '}
                </b>
              </p>
              <p>
                {this.props.translate('RFM.subject')} {data.subject}
              </p>
              <p className="comment">
                {this.props.translate('RFM.location')} {this.getSuiteLocation()}
              </p>
              <p className="comment">
                {this.props.translate('RFM.category')} {data.category}
              </p>
              <p className="comment">
                {this.props.translate('RFM.description')} {data.description}
              </p>
              <p className="comment">
                {this.props.translate('RFM.additionalInformation')} {data.tenant_note}
              </p>
              {!hostIsBoardwalk() && (
                <p className="comment">
                  {this.props.translate('RFM.createdBy')} {data.created_by}
                </p>
              )}
            </div>
            {this._renderMaintenanceNotes({ readOnly: !isTicketOpen })}
            {this._renderImages({ readOnly: !isTicketOpen })}
          </DialogContent>
          <DialogActions style={{ display: 'block' }}>
            <FlatButton
              onClick={this.props.toggleDialog}
              id="close-button-maintenance"
              style={{ color: AccentColor(), textTransform: 'uppercase' }}
            >
              {this.props.translate('close')}
            </FlatButton>
            {isTicketOpen && (
              <FlatButton
                variant="raised"
                onClick={this.props.submitMaintenance}
                disabled={this.props.submitting}
                id="submit-button"
                style={{
                  color: 'white',
                  backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
                  textTransform: 'uppercase',
                }}
              >
                {this.props.translate('save')}
              </FlatButton>
            )}
          </DialogActions>
        </Dialog>
        <ConfirmationDialog
          fullScreen={this.props.fullScreen}
          showDialog={this.state.confirmDialogOpen}
          hideDialog={this.toggleConfirmDialog}
          userConfirmVerbiage={this.props.translate('request_type.yes')}
          dialogTitle={serviceRequestOptions(cancelTicketOptions)}
          dialogBodyVerbiage={serviceRequestOptions(cancelTicketAreYouSureOptions)}
          userConfirmAction={() => {
            this.props.cancelMaintenanceTicket(this.props.ticketInfo.id);
            this.props.toggleDialog();
            this.toggleConfirmDialog();
          }}
        />
      </div>
    );
  }

  _renderAddress = () => {
    const { ticketInfo } = this.props;
    if (ticketInfo && ticketInfo.property_country === 'Netherlands') {
      return (
        <div className="col-xs-8" style={{ padding: '0px 5px', textTransform: 'uppercase' }}>
          <p id="no-margin">{ticketInfo && ticketInfo.property_street}</p>
          <p id="no-margin">
            {ticketInfo && ticketInfo.property_postal_code} {ticketInfo && ticketInfo.property_city}
          </p>
        </div>
      );
    }

    return (
      <div className="col-xs-8" style={{ padding: '0px 5px', textTransform: 'uppercase' }}>
        <p id="no-margin">{ticketInfo && ticketInfo.property_street}</p>
        <p id="no-margin">
          {ticketInfo && ticketInfo.property_city} {ticketInfo && ticketInfo.property_province}{' '}
        </p>
        <p id="no-margin">
          {ticketInfo && ticketInfo.property_country}{' '}
          {ticketInfo && ticketInfo.property_postal_code}{' '}
        </p>
      </div>
    );
  };

  _renderMaintenanceNotes = ({ readOnly }) => {
    if (!this.props.ticketInfo) return null;
    if (hostIsBoardwalk()) return null;
    return (
      <TenantMaintenanceNotes ticketId={this.props.ticketInfo.id} isResident readOnly={readOnly} />
    );
  };

  _renderProgressVerbiage = () => {
    const data = this.props.ticketInfo || {};

    if (['qa-concertproperties.com', 'concertproperties.com'].includes(window.CLIENT_URL)) {
      return <ProgressConcert status={data.status} />;
    }

    return <ProgressInEnglish status={data.status} />;
  };

  _renderImages = ({ readOnly }) => {
    const maintenancePhotos = this.getPhotos();
    if (!maintenancePhotos) return null;

    let dropZoneLabel;

    if (readOnly) {
      if (maintenancePhotos.length === 0) {
        dropZoneLabel = getTranslatedString('maintenancePhotos.closed.none');
      } else {
        dropZoneLabel = getTranslatedString('maintenancePhotos.closed');
      }
    }

    return (
      <div>
        <div className="row" style={style.receipt_header}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textTransform: 'uppercase' }}>
              {' '}
              {this.props.translate('photos')}{' '}
            </p>
          </div>
        </div>

        <div className="row" style={{ fontSize: '15px', marginTop: '10px', marginBottom: '10px' }}>
          <div className="col-xs-12" style={{ padding: '0px 5px', fontWeight: '800' }}>
            <Field
              name="files"
              component={RenderDropzoneMultiFileInput}
              acceptedFileTypes=".jpeg, .png, .jpg, .pdf"
              uploadedFilesKey="photos"
              formName={FORM_NAME}
              useLightbox={true}
              label={dropZoneLabel}
              readOnly={readOnly}
            />
          </div>
        </div>
      </div>
    );
  };
}

const FormComponent = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(TenantMaintenanceDialog);

export default localize()(withMobileDialog()(FormComponent));
